import { Bell } from "lucide-react";

interface PushPrimingSheetProps {
  open: boolean;
  busy?: boolean;
  onEnable: () => void;
  onDismiss: () => void;
}

export default function PushPrimingSheet({ open, busy, onEnable, onDismiss }: PushPrimingSheetProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-end" style={{ background: "rgba(42,24,16,0.4)" }}>
      <div className="w-full rounded-t-3xl bg-[#FFF6EC] p-6 pb-8 shadow-[0_-20px_50px_-20px_rgba(42,24,16,0.4)]">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FBE0D6]">
          <Bell className="h-7 w-7" style={{ color: "#F44321" }} />
        </div>
        <h2 className="text-center text-lg font-extrabold text-[#2A1810]">Stay in the loop</h2>
        <p className="mt-2 text-center text-sm font-semibold text-[#8A6050]">
          We'll let you know when new courses or training are updated.
        </p>
        <button
          onClick={onEnable}
          disabled={busy}
          className="mt-6 w-full rounded-xl bg-[#F44321] py-3 text-sm font-extrabold text-white shadow-[0_12px_24px_-12px_rgba(244,67,33,0.7)] disabled:opacity-60"
        >
          {busy ? "Enabling…" : "Enable notifications"}
        </button>
        <button
          onClick={onDismiss}
          disabled={busy}
          className="mt-2 w-full rounded-xl py-3 text-sm font-bold text-[#8A6050]"
        >
          Not now
        </button>
      </div>
    </div>
  );
}
